// extracted by mini-css-extract-plugin
module.exports = {"greenBorder":"styles_greenBorder__xrcJB","greyBorder":"styles_greyBorder__wBbYt","firstItem":"styles_firstItem__MVtZo"};